var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageContainer',[_c('AmeliproCard',{attrs:{"no-card-header":""}},[_c('Historique')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }